import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components';
import Intl from 'src/components/Intl';

import Input from './elements/Input';
import CountrySelector from './elements/CountrySelector';
import Select from './elements/Select';
import CompoundSelect from './elements/CompoundSelect';
import Checkbox from './elements/Checkbox';
import Button from 'components/Button';
import vw from 'src/styles/utils';
import media from 'src/styles/media';

import questionSelections from 'src/data/questionSelections';

function Form(props) {
  const { email, formType } = props;
  const [realtorAnswerIndex, setRealtorAnswerIndex] = useState(0);
  const [isRealtor, setIsRealtor] = useState(null);
  const [isWorkingWithRealtor, setIsWorkingWithRealtor] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [homeownerTABIndex, setHomeownerTABIndex] = useState(0);




  const handleSelectIsRealtor = (e) => {
    setIsRealtor(e.target.selectedIndex);
    //console.log(e.target.selectedIndex)
  }

  const handleSelectIsWorkingWithRealtor = (e) => {
    setIsWorkingWithRealtor(e.target.selectedIndex);
  }

  // const handleSelectRealtor = (e) => {
  //   let isRealtorElement = document.getElementById(questionSelections.isRealtor.id);
  //   let isWorkingWithRealtorElement = document.getElementById(questionSelections.isWorkingWithRealtor.id);

  //   switch (e.target.selectedIndex) {
  //     case 1:
  //       isRealtorElement.selectedIndex = 2;
  //       isWorkingWithRealtorElement.selectedIndex = 1;
  //       break;
  //     case 2:
  //       isRealtorElement.selectedIndex = 1;
  //       isWorkingWithRealtorElement.selectedIndex = 1;
  //       break;
  //     case 3:
  //       isRealtorElement.selectedIndex = 1;
  //       isWorkingWithRealtorElement.selectedIndex = 2;
  //       break;
  //     case 4:
  //       isRealtorElement.selectedIndex = 1;
  //       isWorkingWithRealtorElement.selectedIndex = 1;
  //       break;
  //     default:
  //       isRealtorElement.selectedIndex = 1;
  //       isWorkingWithRealtorElement.selectedIndex = 1;
  //       break;
  //   }

  //   setRealtorAnswerIndex(e.target.selectedIndex);
  // }

  const handleSelectHomeownerTAB = (e) => {
    let isTABRetailerElement = document.getElementById(questionSelections.isTABRetailer.id);
    let isTABTenantElement = document.getElementById(questionSelections.isTABTenant.id);
    let isTABHomownerElement = document.getElementById(questionSelections.isTABHomeowner.id);

    switch (e.target.selectedIndex) {
      case 1:
        isTABRetailerElement.selectedIndex = 1;
        isTABTenantElement.selectedIndex = 1;
        isTABHomownerElement.selectedIndex = 1;
        break;
      case 2:
        isTABRetailerElement.selectedIndex = 2;
        isTABTenantElement.selectedIndex = 1;
        isTABHomownerElement.selectedIndex = 1;
        break;
      case 3:
        isTABRetailerElement.selectedIndex = 1;
        isTABTenantElement.selectedIndex = 2;
        isTABHomownerElement.selectedIndex = 1;
        break;
      case 4:
        isTABRetailerElement.selectedIndex = 1;
        isTABTenantElement.selectedIndex = 1;
        isTABHomownerElement.selectedIndex = 2;
        break;
      default:
        isTABRetailerElement.selectedIndex = 1;
        isTABTenantElement.selectedIndex = 1;
        isTABHomownerElement.selectedIndex = 1;
        break;
    }

    // setHomeownerTABIndex(e.target.selectedIndex);
  }


  const $form = useRef();
  let submitting = true;





  const handleFormSubmit = async (e) => {
    e.preventDefault();

    var form = $form.current;
    var missing = '';
    var required = { contact_email: 'Email' };
    var customRequired = document.querySelectorAll(
      'input:required, textarea:required, select:required, checkbox:required'
    );

    var FirstName = document.getElementById('contact[first_name]').value;
    var regexLetter = /^[\u4E00-\u9FFF\u3400-\u4DFF\uF900-\uFAFFa-zA-Z /.-]*$/;
    var regexLetterNumber = /^[a-zA-Z0-9 ]*$/;
    var regexPhoneNumber = /^[0-9 -+.]*$/;
    if (!regexLetter.test(FirstName)) {

      missing += '- First name is invalid\r\n';
    }
    var LastName = document.getElementById('contact[last_name]').value;
    if (!regexLetter.test(LastName)) {

      missing += '- Last name is invalid\r\n';
    }
    var PostalCode = document.getElementById('contact[postcode]').value;
    if (!regexLetterNumber.test(PostalCode)) {

      missing += '- Postal code is invalid\r\n';
    }



    // Adds custom required inputs to the 'required' object
    for (var i = 0; i < customRequired.length; i++) {
      required[customRequired[i].id] = customRequired[
        i
      ].parentNode.firstElementChild.innerHTML.replace('*', '');
    }


    // Iterates through required fields and adds any that have
    // not been populated to 'missing' list

    // if (required.has('answers[3040][answers]')) {
    //   console.log(111)
    // }

    required['answers[3040][answers]'] = 'Consent Required';

    for (let key in required) {
      var elements = Array.from(
        document.querySelectorAll("[id^='" + key + "']")
      );

      if (elements.length > 0) {
        let missing_field = true;

        elements.forEach(function (el) {
          if (
            el.length < 1 ||
            (el &&
              ((el.type === 'checkbox' && el.checked) ||
                (el.type === 'radio' && el.checked) ||
                (el.type !== 'radio' && el.type !== 'checkbox' && el.value) ||
                (document.getElementById(key + '_other_text') &&
                  document.getElementById(key + '_other_text').value)))
          ) {
            missing_field = false;
          }
        });

        if (missing_field) {

          missing += '- ' + required[key] + '\r\n';
          // console.log('- ' + required[key])
          // missing += ' ';
        }
      }
    }

    // Tests email input value against RFC 5322 Official Standard Email Regex
    var email = document.getElementById('contact[email]').value;
    if (
      //eslint-disable-next-line
      !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
        email
      )
    ) {
      missing += '- Email is invalid\r\n';
      // missing += ' ';
    }

    if (isWorkingWithRealtor === 2) {

      var realtorEmail = document.getElementById('answers[8456][answers]').value;
      if (
        //eslint-disable-next-line
        !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
          realtorEmail
        )
      ) {
        missing += '- Realtor email is invalid\r\n';
        // missing += ' ';
      }
    }




    if (missing !== '') {
      alert('The following fields are incomplete:\r\n' + missing);
      // alert('Please fill out the required fields.');
      return false;
    }

    if (submitting) {
      // alert(document.getElementById('contact[email]').value)
      form.action = "https://hook.integromat.com/t82kmtsaphfcjpqc61s7io244c811asu";
      form.submit();
      setIsSubmitting(true);
      return false;

    }
    submitting = true;

  }

  return (
    <Intl>
      {(t, { locale }) => {
        return (
          <Root method="post" accept-charset="UTF-8" ref={$form} >
            {/* https://spark.re/shape-marketing-corp/brentwood-five/register/web-registration-form */}
            <Fields>
              <Input
                type="text"
                label={t.register.form.firstName}
                gridArea="firstName"
                id="contact[first_name]"
                required
              />
              <Input
                label={t.register.form.lastName}
                gridArea="lastName"
                id="contact[last_name]"
                restriction="[a-z\d]*"
                required
              />
              <Input
                label={t.register.form.email}
                gridArea="email"
                id="contact[email]"
                value={email}
                required
              />
              {/* {
          
          email !== null ? (
            <Input
            label="Email*"
            gridArea="email"
            id="contact[email]"
            value={email}
            disabled
            required
          />
          ) : (
            <Input
            label="Email*"
            gridArea="email"
            id="contact[email]"
            required
          />
            
          )
        } */}

              <Input
                label={t.register.form.phone}
                gridArea="phone"
                id="contact[phone]"
                type="number"
                required
              />
              <Input
                label={t.register.form.postalCode}
                gridArea="postalCode"
                id="contact[postcode]"
                required
              />
              <CountrySelector
                gridArea="country"
              />
              <Select
                label={t.register.form.hearAbout}
                gridArea="hearAbout"
                question={t.register.form.questionSelections.hearAbout}
                required
              />
              <RealtorQuestionWrapper gridArea="RealtorQuestionWrapper">
                {/* <CompoundSelect
            label="Are you a realtor/working with a realtor?*"
            gridArea="isOrWorkingWithRealtor"
            question={questionSelections.isOrWorkingWithRealtor}
            onChange={handleSelectRealtor}
            required
          /> */}
                <Select
                  label={t.register.form.isRealtor}
                  question={t.register.form.questionSelections.isRealtor}
                  onChange={handleSelectIsRealtor}
                />
                <Input
                  label={t.register.form.isRealtorEmployer}
                  gridArea="isRealtorEmployer"
                  id="contact[brokerage_name]"
                  hidden={isRealtor !== 2}
                  required={isRealtor === 2}
                />
                <Select
                  label={t.register.form.isWorkingWithRealtor}
                  question={t.register.form.questionSelections.isWorkingWithRealtor}
                  onChange={handleSelectIsWorkingWithRealtor}
                />
                <Input
                  label={t.register.form.isWorkingWithRealtorName}
                  gridArea="isWorkingWithRealtorName"
                  id="answers[8455][answers]"
                  hidden={isWorkingWithRealtor !== 2}
                />
                <Input
                  label={t.register.form.isWorkingWithRealtorEmail}
                  gridArea="isWorkingWithRealtorEmail"
                  id="answers[8456][answers]"
                  hidden={isWorkingWithRealtor !== 2}
                  required={isWorkingWithRealtor === 2}
                />
                <Input
                  label={t.register.form.isWorkingWithRealtorBrokerage}
                  gridArea="isWorkingWithRealtorBrokerage"
                  id="answers[8457][answers]"
                  hidden={isWorkingWithRealtor !== 2}
                />
              </RealtorQuestionWrapper>
              <CompoundSelect
                label={t.register.form.isHomeownerAtTAB}
                gridArea="isHomeownerAtTAB"
                question={t.register.form.questionSelections.isHomeownerAtTAB}
                onChange={handleSelectHomeownerTAB}
                required
              />
              <HiddenSelect
                label={t.register.form.isTABRetailer}
                question={t.register.form.questionSelections.isTABRetailer}
              />
              {/* <Input
          label="Name of Retailer"
          gridArea="isTABRetailerName"
          id="answers[8556][answers]"
          hidden={homeownerTABIndex!==2}
        /> */}
              <HiddenSelect
                label={t.register.form.isTABTenant}
                question={t.register.form.questionSelections.isTABTenant}
              />
              <HiddenSelect
                label={t.register.form.isTABHomeowner}
                question={t.register.form.questionSelections.isTABHomeowner}
              />
              {/* <Input
          label="Your Unit Number"
          gridArea="isTABTenantUnit"
          id="answers[8607][answers]"
          hidden={homeownerTABIndex!==3}
        /> */}
              <Checkbox
                label={t.register.form.checkKeepMe}
                gridArea="checkKeepMe"
                id="answers[3040][answers]"
                key="Consent Required"
                required
              />
            </Fields>
            {/* <SubmitButton onClick={$this.handleFormSubmit(e)}>Submit</SubmitButton> */}
            <Button
              text={t.register.form.submit}
              handleClick={(e) => handleFormSubmit(e)}
              isSubmitting={isSubmitting}
            />
            <Distclaimer>
              {t.register.form.distclaimer}
            </Distclaimer>
            <input name="utf8" type="hidden" value="✓" />
            <input type="hidden" name="authenticity_token" value="WGQUGNnJbyfJDknUWoJXZTYTkKxsP0Htj6Jbr8SOdMOUvseR4zqT85tc4zKAuamQKcYBjwtLhe7CtDcz8UeAvw==" />
            {
              formType === 'Web' ? (
                <>
                  <input type="hidden" name="source" id="source" value="Website" />
                  <input type="hidden" name="redirect_success" id="redirect_success" value="https://homes.theamazingbrentwood.com/thank-you/" />
                </>
              ) : (
                <>
                  <input type="hidden" name="source" id="source" value="PC SignUp" />

                  {isRealtor === 2 ?(
                    <>
                    <input type="hidden" name="redirect_success" id="redirect_success" value={window.location.origin + '/thankyou/'} />
                    </>
                  ):(
                    <>
                    <input type="hidden" name="redirect_success" id="redirect_success" value={window.location.origin + '/dr/'} />
                    </>
                  )
                  }
                  
                </>

              )
            }
            <input type="hidden" name="redirect_error" id="redirect_error" value="https://theamazingbrentwood.com/reside/sales-registration/#register-form" />
            <input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response" />
            <input type="hidden" name="action" value="validate_captcha" />
            {/* <input type="text" style="opacity: 0; display: none;" name="are_you_simulated" id="are_you_simulated" placeholder="Leave this field blank" /> */}
          </Root>
        );
      }}
    </Intl>
  );
};

const Root = styled.form`
  width: 100%;

  @media ${media.desktop} {
    width: 75%;
  }
`;

const Fields = styled.div`
  display: grid;
  grid-template-areas: 
    "firstName"
    "lastName"
    "email"
    "phone"
    "postalCode"
    "country"
    "hearAbout"
    "RealtorQuestionWrapper"
    "isHomeownerAtTAB"
    "isTABRetailerName"
    "isTABTenantUnit"
    "checkKeepMe";

  ${vw('grid-column-gap', 0, 24, 20)}
  ${vw('grid-row-gap', 10)}

  @media ${media.tablet} {
    grid-template-areas: 
      "firstName lastName"
      "email phone"
      "postalCode country"
      "hearAbout ."
      "RealtorQuestionWrapper RealtorQuestionWrapper"
      "isHomeownerAtTAB isHomeownerAtTAB"
      "isTABRetailerName isTABRetailerName"
      "isTABTenantUnit isTABTenantUnit"
      "checkKeepMe checkKeepMe";
  }
`;

const HiddenSelect = styled(Select)`
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0;
  pointer-events: none;
`;

const RealtorQuestionWrapper = styled.div`
  > * {
    &:not(:first-of-type) {
      ${vw('margin-top', 10)}
    }
  }
`;



const Distclaimer = styled.p`
  font-family: Big Caslon;
  font-style: normal;
  font-weight: normal;
  color: #000000;

  ${vw('font-size', 11)}
  ${vw('line-height', 13)}
  ${vw('letter-spacing', 0.06)}
  ${vw('margin-top', 15, 17)}
`;

export default Form

